import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface loginPayloadDetails {
  accessToken: string;
  createdAt: string;
  createdBy: string | null;
  email: string;
  firstName: string;
  id: string;
  isActive: boolean;
  lastName: string;
  roleId: string;
  featureAccess: string[];
  updatedAt: string;
}

interface AuthState {
  token_details: loginPayloadDetails | null;
  snackbarDetails: { type: string; message: string };
}

let storedUser = localStorage.getItem("odessa_user_details");

let initialState: AuthState = {
  token_details: storedUser ? JSON.parse(storedUser) : null,
  snackbarDetails: { type: "", message: "" },
};

const AuthSliceReducer = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    setAuthToken(state, action: PayloadAction<loginPayloadDetails | null>) {
      state.token_details = action.payload;
    },
    setSnackbarDetails(state, action) {
      state.snackbarDetails = action.payload;
    },
  },
});

export const { setAuthToken, setSnackbarDetails } = AuthSliceReducer.actions;

export default AuthSliceReducer.reducer;
